import { __ } from '@wordpress/i18n';

const EditFieldContent = ({ field, onEdit, onDelete, onMoveUp, onMoveDown, canMoveUp, canMoveDown }) => {
  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(field, e);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(field.id, e);
  };

  const handleMoveUp = (e) => {
    e.stopPropagation();
    onMoveUp(field.id, e);
  };

  const handleMoveDown = (e) => {
    e.stopPropagation();
    onMoveDown(field.id, e);
  };

  return (
    <div className="hvnly--builder---api_property__builder___field_actions">
      <span className="hvnly--builder---api_property__builder___field_label">
        {field.label}
      </span>
      
      <div className="hvnly--builder---api_property__builder___field_action_buttons">
        {/* Move Up Button */}
        {canMoveUp && (
          <button
            type="button"
            className="hvnly--builder---api_property__builder___field_action_btn hvnly--builder---api_property__builder___field_move_up_btn"
            onClick={handleMoveUp}
            title={__("Move Up", "havenlytics")}
          >
            <i className="fas fa-arrow-up"></i>
          </button>
        )}
        
        {/* Move Down Button */}
        {canMoveDown && (
          <button
            type="button"
            className="hvnly--builder---api_property__builder___field_action_btn hvnly--builder---api_property__builder___field_move_down_btn"
            onClick={handleMoveDown}
            title={__("Move Down", "havenlytics")}
          >
            <i className="fas fa-arrow-down"></i>
          </button>
        )}
        
        {/* Edit Button */}
        <button
          type="button"
          className="hvnly--builder---api_property__builder___field_action_btn hvnly--builder---api_property__builder___field_edit_btn"
          onClick={handleEdit}
          title={__("Edit", "havenlytics")}
        >
          <i className="fas fa-edit"></i>
        </button>
        
        {/* Delete Button */}
        <button
          type="button"
          className="hvnly--builder---api_property__builder___field_action_btn hvnly--builder---api_property__builder___field_delete_btn"
          onClick={handleDelete}
          title={__("Delete", "havenlytics")}
        >
          <i className="fas fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default EditFieldContent;